export const castWritable = (mutable) => mutable;
